import { format } from "date-fns";
import { fromZonedTime, toZonedTime } from "date-fns-tz";

export const tenant = window.location.host.split('.')[0]

export const API_URL = process.env.REACT_APP_API_URL.replace('tenant', tenant);

export const URL_EXACTIAN = process.env.REACT_APP_API_EXACTIAN_URL.replace('tenant', tenant);

export const APP_VERSION = process.env.REACT_APP_VERSION;

export const setUserData = (user) => {
    localStorage.setItem('userData', JSON.stringify(user));
};

export const setInstanceInfo = (tenant) => localStorage.setItem('tenant', JSON.stringify(tenant));;

export const isAuthenticated = () => localStorage.getItem("userData");

export const getDataUserByKey = (key) => {
    const dataUser = JSON.parse(localStorage.getItem("userData"));
    return dataUser && dataUser[key] ? dataUser[key] : null
};

export const havePermission = (permissionId) => {
    const userPermissions = getDataUserByKey('permissions');
    return userPermissions ? userPermissions.some(userPermission => userPermission.access_permission_id === permissionId) : false;
};

export const getTokenUser = () => JSON.parse(localStorage.getItem("userData")).token;

export const getUserOpening = () => getDataUserByKey('accessOpening');

export const getUserBuilding = () => getDataUserByKey('accessBuilding');

/** Limpia apertura y edificio en userData (al cambiar de apertura el edificio deja de ser válido). */
export const clearUserAccessOpeningAndBuilding = () => {
    const raw = localStorage.getItem('userData');
    if (!raw) return;
    const userData = JSON.parse(raw);
    delete userData.accessOpening;
    delete userData.accessBuilding;
    setUserData(userData);
};

export const clearUserAccessBuilding = () => {
    const raw = localStorage.getItem('userData');
    if (!raw) return;
    const userData = JSON.parse(raw);
    delete userData.accessBuilding;
    setUserData(userData);
};

export const getScanCamera = () => JSON.parse(localStorage.getItem("scanCamera"));

export const setScanCamera = (newCamera) => localStorage.setItem('scanCamera', JSON.stringify(newCamera));

export const getTenantInfoByKey = (key) => {
    const tenant = JSON.parse(localStorage.getItem('tenant'));
    return !!tenant ? tenant[key] : null;
};

export const isoToDate = (date, format = getDataUserByKey('date_format') || getTenantInfoByKey('date_format'), separator = getDataUserByKey('date_separator') || getTenantInfoByKey('date_separator')) => {
    try {
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        const hour = date.substring(8, 10);
        const minutes = date.substring(10, 12);
        const second = date.substring(12, 14);

        let order;

        switch (format) {
            case 'DDMMYYYY':
                order = [...(day ? [day] : []), month, year];
                break;
            case 'MMDDYYYY':
                order = [month, ...(day ? [day] : []), year];
                break;
            case 'YYYYMMDD':
                order = [year, month, ...(day ? [day] : [])];
                break;
            case 'YYYYDDMM':
                order = [year, ...(day ? [day] : []), month];
                break;
            case 'DDYYYYMM':
                order = [day, year, month];
                break;
            case 'MMYYYYDD':
                order = [month, year, ...(day ? [day] : [])];
                break;
            default:
                throw new Error('Formato de fecha inválido');
        }
        if (hour && minutes && second) {
            return `${order.join(separator)}T${hour}:${minutes}:${second}`;
        } else {
            return order.join(separator);
        }
    } catch (e) {
        return '-'
    }
}

export const ISOtoTime = (ISOTime) => {
    try {
        const hour = ISOTime.substring(0, 2);
        const minutes = ISOTime.substring(2, 4);
        return `${hour}:${minutes}`

    } catch (e) {
        console.log(e)
        return '-'
    }
};


export const getDateInString = (
    date = new Date(),
    format = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }
) => {
    const finalDate = new Date(date);
    finalDate.setHours(24, 0, 0, 0); // Establecer la última hora del día
    return new Intl.DateTimeFormat('default', format).format(finalDate);
};

export const operarFecha = (fecha, tipoOperacion, cantidadDias) => {
    var nuevaFecha = new Date(fecha);

    if (tipoOperacion === 'sumar') {
        nuevaFecha.setDate(nuevaFecha.getDate() + cantidadDias);
    }

    if (tipoOperacion === 'restar') {
        nuevaFecha.setDate(nuevaFecha.getDate() - cantidadDias);
    }
    return nuevaFecha.toJSON().slice(0, 10);
};

export const replaceExpecialCharacters = (str, caracteresEspeciales = /[^\w\s.\-0-9ñÑáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙäëïöüÄËÏÖÜâêîôûÂÊÎÔÛç$%@&#!\\()\u20AC¿¡?]+/g, reemplazo = '') => {
    const strSinCaracteresEspeciales = str.replace(caracteresEspeciales, reemplazo)
    return strSinCaracteresEspeciales;
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const parseMillisecondsToHoursAndMinutes = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    return formattedTime;
}

const getHeaderExactian = () => {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${getTokenUser()}`,
    };
};

const getHeaderBasicAuth = () => {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Basic ${btoa(`${process.env.REACT_APP_AUTH_USER}:${process.env.REACT_APP_AUTH_PASS}`)}`,
    };
};

export const getConfigExactian = (method, body, signal, headers = getHeaderExactian()) => {
    return {
        headers: headers,
        method: method,
        body: JSON.stringify(body),
        signal,
    };
};

export const getConfigBasicAuth = (method, body, signal, headers = getHeaderBasicAuth()) => {
    return {
        headers: headers,
        method: method,
        body: JSON.stringify(body),
        signal,
    };
};

export const colorAptitude = (apt) => {
    if (apt === 0 || apt === 99) {
        return 'colorbk-success-strong';
    }
    if (apt === 2) {
        return 'colorbk-danger-strong';
    }
    return 'colorbk-warning-strong';
}

export const getCurrentItems = (itmes, page, itemsPerPage = 5) => {

    const indexOfLastItem = page * itemsPerPage;

    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = itmes.slice(indexOfFirstItem, indexOfLastItem);

    return currentItems
}

export const generateUId = () => {

    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 10000);

    return `id_${timestamp}_${random}`;

}

export const getTimeZoneMode = () => {
    //Posibles valores "USER_TZ", "INSTANCE_TZ"
    return getTenantInfoByKey('tz_mode');
};

export const getTimeZone = () => {

    const timeZoneMode = getTimeZoneMode();

    if (timeZoneMode === 'INSTANCE_TZ') {
        //Default America/Argentina/Buenos_Aires
        return getTenantInfoByKey('instance_tz');
    } else {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return userTimeZone;
    }
};

export const convertUserDateToArgentinaTimeZone = ({
    initialDate,
    returnFormat = 'yyyy-MM-dd HH:mm:ss'
}) => {

    const [date, time] = initialDate.split(' ');

    const [year, month, day] = date.split('-').map(Number);

    const [hour, minute, second] = time.split(':').map(Number);

    const dateObject = new Date(year, month - 1, day, hour, minute, second);

    const userTimeZone = getTimeZone();

    const argentinaTimeZone = 'America/Argentina/Buenos_Aires';

    const utcDate = fromZonedTime(dateObject, userTimeZone);

    const convertedDate = toZonedTime(utcDate, argentinaTimeZone);

    return format(convertedDate, returnFormat, { timeZone: argentinaTimeZone });

};

export const convertDateToUserTimeZone = ({
    initialDate,
    returnFormat = 'yyyy-MM-dd HH:mm:ss'
}) => {

    // Convertir desde la zona horaria de Argentina a UTC
    const [date, time] = initialDate.split(' ');

    const [year, month, day] = date.split('-').map(Number);

    const [hour, minute, second] = time.split(':').map(Number);

    const dateObject = new Date(year, month - 1, day, hour, minute, second);

    const argentinaTimeZone = 'America/Argentina/Buenos_Aires';

    const utcDate = fromZonedTime(dateObject, argentinaTimeZone);

    const timeZone = getTimeZone();

    // Convertir desde UTC a la zona horaria deseada
    const convertedDate = toZonedTime(utcDate, timeZone);

    // Formatear de vuelta al formato original YYYY-MM-DD HH:mm:ss
    return format(convertedDate, returnFormat, { timeZone });

};
